import {
  Directive,
  ElementRef,
  Renderer2,
  effect,
  inject,
  input,
} from '@angular/core';

@Directive({ selector: '[pluginsLineLimit]' })
export class LineLimitDirective {
  private elemRef = inject(ElementRef) as ElementRef<HTMLElement>;
  private renderer = inject(Renderer2);

  readonly pluginsLineLimit = input(2, {
    transform: (lines) => (typeof lines === 'number' ? lines : 2),
  });

  constructor() {
    this.setHostStyles();
  }

  private lineLimitEffect = effect(() => {
    this.renderer.setStyle(
      this.elemRef.nativeElement,
      '-webkit-line-clamp',
      this.pluginsLineLimit(),
    );
  });

  private setHostStyles() {
    this.renderer.setStyle(
      this.elemRef.nativeElement,
      'display',
      '-webkit-box',
    );
    this.renderer.setStyle(
      this.elemRef.nativeElement,
      '-webkit-box-orient',
      'vertical',
    );
    this.renderer.setStyle(
      this.elemRef.nativeElement,
      'text-overflow',
      'ellipsis',
    );
    this.renderer.setStyle(this.elemRef.nativeElement, 'overflow', 'hidden');
  }
}
